import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import values from 'lodash/values';
import get from 'lodash/get';

import {  
  loadRetailers,
  loadPublishersForCampaign,
  updatePublishersForCampaign
} from '../../shared/redux/entities/actions';

function getRetailers(state){
  return values(state.entities.companies).filter((c) => !c.isBrand)
}


function mapStateToProps(state,props){
  //TODO: Connect Redux state to ProviderCampaignPublishers
  return {
    campaign:get(state,['entities','campaigns',props.campaignId],{}),
    publishers:getRetailers(state),
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to ProviderCampaignPublishers
  return bindActionCreators({
    loadRetailers,
    loadPublishersForCampaign,
    updatePublishersForCampaign
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignPublishers/connect.js